export default {
  "emailMarketing.title": "邮件营销",
  "emailMarketing.column.no": "#序号",
  "emailMarketing.column.taskId": "任务ID",
  "emailMarketing.column.title": "标题",
  "emailMarketing.column.scopeTypeDesc": "推送范围",
  "emailMarketing.column.taskType": "类型",
  "emailMarketing.column.statusDesc": "状态",
  "emailMarketing.column.userNum": "用户数",
  "emailMarketing.column.successNum": "成功数",
  "emailMarketing.column.createTime": "创建时间",
  "emailMarketing.column.pushTime": "发送时间",
  "emailMarketing.column.action": "操作",
  "emailMarketing.action.delete": "删除",
  "emailMarketing.action.start": "启动任务",
  "emailMarketing.action.stop": "停止任务",
  "emailMarketing.action.details": "详情",
  "emailMarketing.action.edit": "编辑",
  "emailMarketing.form.taskType": "类型",
  "emailMarketing.form.siteKey": "绑定站点",
  "emailMarketing.form.taskType.once": "一次性任务",
  "emailMarketing.form.taskType.fixed": "固定任务",
  "emailMarketing.form.template": "模板",
  "emailMarketing.form.select.placeholder": "请选择",
  "emailMarketing.form.title": "标题",
  "emailMarketing.form.title.placeholder": "请输入标题",
  "emailMarketing.form.title.siteKey": "请选择站点",
  "emailMarketing.form.pushTime": "开始时间",
  "emailMarketing.form.pushTime.placeholder": "选择时间",
  "emailMarketing.form.taskCycleDays": "周期天数",
  "emailMarketing.form.taskCycleDays.placeholder": "输入天数",
  "emailMarketing.form.pushScope": "推送范围",
  "emailMarketing.form.pushScope.recharge": "最近几天充值",
  "emailMarketing.form.pushScope.designated": "指定用户",
  "emailMarketing.form.scopeTimeType": "时间范围类型",
  "emailMarketing.form.scopeTimeType.scope": "范围",
  "emailMarketing.form.scopeTimeType.lately": "最近",
  "emailMarketing.form.scopeTime": "时间范围",
  "emailMarketing.form.scopeTime.start": "开始时间",
  "emailMarketing.form.scopeTime.end": "结束时间",
  "emailMarketing.form.scopeTimeDays": "最近天数",
  "emailMarketing.form.scopeTimeDays.placeholder": "输入天数",
  "emailMarketing.form.day": "天",
  "emailMarketing.form.usernoList": "用户编号",
  "emailMarketing.form.usernoList.placeholder": "请输入用户编号，逗号分隔",
  "emailMarketing.form.content": "内容",
  "emailMarketing.form.content.placeholder": "输入内容",
  "emailMarketing.confirm.delete.title": "删除邮件任务",
  "emailMarketing.confirm.delete.content": "确定要删除此邮件任务吗？",
  "emailMarketing.confirm.start.title": "启动任务",
  "emailMarketing.confirm.start.content": "确定要启动此任务吗？",
  "emailMarketing.confirm.stop.title": "停止任务",
  "emailMarketing.confirm.stop.content": "确定要停止此任务吗？",
  "emailMarketing.confirm.ok": "确认",
  "emailMarketing.confirm.cancel": "取消",
  "emailMarketing.add.once": "新建邮件",
  "emailMarketing.add.fixed": "新建固定邮件",
  "emailMarketing.type.once": "一次性任务",
  "emailMarketing.type.fixed": "固定任务",
  "emailMarketing.modal.add.title": "新增邮件任务",
  "emailMarketing.modal.details.title": "邮件任务详情",
  "emailMarketing.modal.edit.title": "编辑邮件任务",
  "emailMarketing.submit.error": "提交失败",
  "emailMarketing.form.cancel": "取消",
  "emailMarketing.form.reset": "重置",
  "emailMarketing.form.submit": "提交",
  
  // Dynamic fields (pushScopeParam 动态字段)
  "emailMarketing.field.registerTime": "注册时间",
  "emailMarketing.field.registerTime.placeholder": "请输入注册时间范围",
  "emailMarketing.field.usernoList": "用户编号",
  "emailMarketing.field.usernoList.placeholder": "请输入用户编号，逗号分隔",
};

